import { render, staticRenderFns } from "./PriceGroup.vue?vue&type=template&id=d083d722&"
import script from "./PriceGroup.vue?vue&type=script&lang=js&"
export * from "./PriceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports